/* VENDORED — GENERATED FILE. Do not hand-edit.
   Regenerate with:  yarn vendor:mondrian

   Giraffe's REAL in-app palette, extracted from the running product's own
   stylesheet. It is here because it CANNOT be read from the host: every
   `--mondrian-*` custom property computes empty inside an app panel, a
   property set on the <iframe> element does not cross, and neither does the
   host's font. The only thing that crosses the boundary is the host's
   LIGHTNESS, by way of `prefers-color-scheme` — see `controlTheme.ts`.

   So the values must live here, and `.mondrian.theme-minimalist` /
   `.mondrian.theme-minimalist-dark` are the two blocks this app renders. The
   other four are production's and are kept only so the theme classes can be
   cleared; a host on one of those reaches us as a lightness and gets our
   minimalist palette in that lightness.

   ⚠️ The selectors are TWO classes, `.mondrian` and `.theme-<name>`. Applying
   one without the other matches no block at all and the panel falls back to
   `:root` — which is production's own fallback, not its minimalist theme, so
   the failure renders as a plausible-looking wrong palette rather than as
   nothing.

   This is a reading of a build, not a contract. It drifts silently from the
   moment it is written; nothing in `verify` notices.

   Source:     https://staging.giraffe.build/v6/assets/style-EpPleb_L.css
   Discovered: https://staging.giraffe.build/v6/
   Captured:   2026-09-04
   Blocks:     7
*/

:root {
  --mondrian-bg: rgb(246, 246, 246);
  --mondrian-bg-dark: #e9e9e9;
  --mondrian-bg-darkest: #e0e0e0;
  --mondrian-bg-lighter: #ffffff;
  --mondrian-chrome: var(--mondrian-bg-darkest);
  --mondrian-hover: color-mix(in srgb, var(--mondrian-text) 10%, transparent);
  --mondrian-row-hover: color-mix(in srgb, var(--mondrian-accent) 12%, var(--mondrian-bg));
  --mondrian-row-selected: color-mix(in srgb, var(--mondrian-accent) 22%, var(--mondrian-bg));
  --mondrian-accent: #457fff;
  --mondrian-cta: var(--mondrian-accent);
  --mondrian-on-accent: #ffffff;
  --mondrian-on-danger: #ffffff;
  --mondrian-border: rgb(207, 207, 207);
  --mondrian-border-bright: rgb(184, 184, 184);
  --mondrian-text: #202020;
  --mondrian-text-bright: #000;
  --mondrian-text-dim: #7e7e7e;
  --mondrian-danger: #dc2626;
  --mondrian-sidebar-sep: rgba(0, 0, 0, .12);
}

.mondrian.theme-dark {
  --mondrian-bg: #282828;
  --mondrian-bg-dark: #3d3d3d;
  --mondrian-bg-darkest: #1b1b1b;
  --mondrian-bg-lighter: #4d4d4d;
  --mondrian-border: #4a4a4a;
  --mondrian-border-bright: #7c7c7c;
  --mondrian-text: #dadada;
  --mondrian-text-bright: #ffffff;
  --mondrian-text-dim: #a9a9a9;
  --mondrian-danger: #fa8f75;
  --mondrian-on-danger: #000000;
  --mondrian-sidebar-sep: rgba(255, 255, 255, .15);
  color-scheme: dark;
}

.mondrian.theme-dark-blue {
  --mondrian-bg: #252e3f;
  --mondrian-bg-dark: #313e4e;
  --mondrian-bg-darkest: #0f1f33;
  --mondrian-bg-lighter: #3c4a5c;
  --mondrian-border: rgba(84, 94, 106, .35);
  --mondrian-border-bright: rgba(84, 94, 106, 1);
  --mondrian-text: #ffffff;
  --mondrian-text-bright: #ffffff;
  --mondrian-text-dim: #767d85;
  --mondrian-danger: #b83e1b;
  --mondrian-sidebar-sep: rgba(255, 255, 255, .12);
  color-scheme: dark;
}

.mondrian.theme-light {
  --mondrian-bg: #f0f0f0;
  --mondrian-bg-dark: #e2e2e2;
  --mondrian-bg-darkest: #dcdcdc;
  --mondrian-bg-lighter: #ffffff;
  --mondrian-border: #b0b0b0;
  --mondrian-border-bright: #8a8a8a;
  --mondrian-text: #2b2b2b;
  --mondrian-text-bright: #000000;
  --mondrian-text-dim: #646464;
  --mondrian-danger: #c41c1c;
  --mondrian-sidebar-sep: rgba(0, 0, 0, .26);
  color-scheme: light;
}

.mondrian.theme-minimalist {
  --mondrian-bg: #ffffff;
  --mondrian-bg-dark: #f1f2f4;
  --mondrian-bg-darkest: #e8e9ec;
  --mondrian-bg-lighter: #f7f7f9;
  --mondrian-chrome: var(--mondrian-bg);
  --mondrian-border: #e4e4e8;
  --mondrian-border-bright: #9aa0ab;
  --mondrian-text: #1f2328;
  --mondrian-text-bright: #000000;
  --mondrian-text-dim: #5f6570;
  --mondrian-danger: #c62a1f;
  --mondrian-sidebar-sep: rgba(0, 0, 0, .06);
  color-scheme: light;
}

.mondrian.theme-minimalist-dark {
  --mondrian-bg: #1e1e1e;
  --mondrian-bg-dark: #2c2c2e;
  --mondrian-bg-darkest: #151516;
  --mondrian-bg-lighter: #333336;
  --mondrian-chrome: var(--mondrian-bg);
  --mondrian-border: #333338;
  --mondrian-border-bright: #66666e;
  --mondrian-text: #e4e4e6;
  --mondrian-text-bright: #ffffff;
  --mondrian-text-dim: #9a9aa2;
  --mondrian-danger: #ff7a68;
  --mondrian-on-danger: #000000;
  --mondrian-sidebar-sep: rgba(255, 255, 255, .08);
  color-scheme: dark;
}

.mondrian.theme-clown {
  --mondrian-bg: #917f91;
  --mondrian-bg-dark: #ff7f00;
  --mondrian-bg-darkest: #d00000;
  --mondrian-bg-lighter: #8fb1ff;
  --mondrian-border: #00ff0d;
  --mondrian-border-bright: #00e5ff;
  --mondrian-text: #005500;
  --mondrian-text-bright: #72dba3;
  --mondrian-text-dim: #7b2d8b;
  --mondrian-danger: #a0522d;
  --mondrian-accent: #facc15;
  --mondrian-on-accent: #000000;
  --mondrian-sidebar-sep: #14b8a6;
  color-scheme: light;
}
